import React from "react";
import { connect } from "react-redux";
import Row from "../../../common/grid/Row";
import Section from "../../../common/section/Section";

import "./Permissions.css";
import { fetchPermissionsForRoles } from "../../../actions/permissions.js";

class Permissions extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			permissions: []
		};
	}

	componentDidMount() {
		const roleIds = this.props.roles.map(r => r.id);
		this.props.fetchPermissionsForRoles(roleIds);
	}

	componentWillReceiveProps(nextProps) {
		this.setState({ permissions: nextProps.permissions });
	}

	render() {
		if (!this.state.permissions) {
			return <div>Loading...</div>;
		}

		const permissions = this.state.permissions;

		const role = this.props.roles
			.map(
				(r, i) =>
					i !== this.props.roles.length - 1
						? r.display_name + ", "
						: r.display_name
			)
			.join("");
		return (
			<Section className="permisions white" heading={`as ${role} you can: `}>
				<div className="title" />
				<Row _gap-16 _wrap _no-grow>
					{ permissions.length!=0 ? permissions.map((p,i)=>{
						return (
							<div className="permisionsTag" key={i}>
									{i + 1}. {p.display_name}
								</div>
						)
					})
					: <div>No Permissions For Users</div>
					}
				</Row>
			</Section>
		);
	}
}

const mapStateToProps = state => {
	return {
		roles: state.auth.currentUser.roles,
		permissions: state.permission
	};
};

export default connect(
	mapStateToProps,
	{ fetchPermissionsForRoles }
)(Permissions);



// WEBPACK FOOTER //
// ./src/components/main/profile/Permisions.js